export const urlAuth = process.env.REACT_APP_API_MAIN_BASE_URL;
export const urlBalance = process.env.REACT_APP_API_SCHEDULES_BASE_URL;
export const urlTransactions = process.env.REACT_APP_API_TRANSACTIONS_BASE_URL;
export const urlReports = process.env.REACT_APP_API_REPORTS_BASE_URL;
export const clientId = process.env.REACT_APP_CLIENT_ID_BACKOFFICE;
export const urlFinances = process.env.REACT_APP_API_ACCOUNTS_BASE_URL;
export const urlPaymentPlan = process.env.REACT_APP_API_PAYMENT_PLANS_BASE_URL;
export const urlReconciliation = process.env.REACT_APP_API_RECONCILIATION_BASE_URL;
export const urlVideos = process.env.REACT_APP_API_VIDEOS;
export const urlPaymentOrders = process.env.REACT_APP_PAYMENT_ORDERS_BASE_URL;

export const urls = {
  LOGIN: `${urlAuth}/auth`,
  RECOVER_PASSWORD: `${urlAuth}/auth/recover-password`,
  CHANGE_PASSWORD: `${urlAuth}/auth/change-password`,
  SCHEDULE_BALANCE: `${urlBalance}/backoffice/balance-extended`,
  SCHEDULE_EVENTS: `${urlBalance}/backoffice/balance-extended`,
  SCHEDULE_TRANSACTIONS: `${urlTransactions}/backoffice/transactions`,
  TRANSACTION: `${urlTransactions}/backoffice/transactions`,
  TRANSACTION_LATEST: `${urlTransactions}/backoffice/transactions-latest`,
  TRANSACTION_SUMMARY: `${urlTransactions}/backoffice/transactions-summary`,
  REPORTS: `${urlReports}/reports`,
  ENTRIES: `${urlFinances}/portal/checking-accounts/statement`,
  ENTRIES_PAGINATED: `${urlFinances}/portal/checking-accounts/statement2`,
  BALANCE: `${urlFinances}/portal/checking-accounts/balance`,
  WITHDRAW: `${urlFinances}/portal/checking-accounts/withdraw`,
  SELLERS_BALANCES_TOTAL: `${urlFinances}/portal/checking-accounts/sellers/balances/total`,
  SELLERS_BALANCES: `${urlFinances}/portal/checking-accounts/sellers/balances`,
  USERS: `${urlAuth}/users`,
  SUBSELLERS: `${urlAuth}/subsellers`,
  AVAILABLE_USERS: `${urlAuth}/subsellers/available_users`,
  SCHEDULES: `${urlBalance}/backoffice/schedules/advanced`,
  SCHEDULES_STATS: `${urlBalance}/backoffice/schedules/advanced/stats`,
  PAYMENT_PLAN: `${urlPaymentPlan}/v1/payment-plan`,
  RECONCILIATION: `${urlReconciliation}/v1/backoffice`,
  PAYMENT_PLAN_PUBLIC: `${urlPaymentPlan}/v1/public/payment-plan`,
  WEBHOOK: `${urlPaymentPlan}/v1/webhook`,
  VIDEOS: `${urlVideos}/v1/videos`,
  TRANSACTION_SUMMARY_ADMIN: `${urlTransactions}/backoffice/transactions-summary-admin`,
  BALANCE_ADMIN:`${urlFinances}/portal/checking-accounts/admin-balance/summary`,
  PAYMENT_PLAN_SUMMARY: `${urlPaymentPlan}/v1/payment-plan/plans-summary`,
  FAQ: `${urlVideos}/v1/faq`,
  FAQ_CLIENT: `${urlVideos}/v1/faq/all`,
  PAYMENT_ORDERS: urlPaymentOrders,
}
